<template>
  <MarketingShell>
    <Main />
  </MarketingShell>
</template>

<script>
import MarketingShell from '@/components/landing/MarketingShell';
import Main from '@/components/successStories/Main';
import { updatePageMeta } from '@/utils/useHeadUtils';

const PAGE_META = {
  title: 'Site Palette success stories — real workflows from designers',
  description:
    'See how product, UX, and senior designers use Site Palette to extract color palettes from websites, export to design tools, and speed up handoff.',
  path: '/success-stories',
};

export default {
  components: {
    MarketingShell,
    Main,
  },
  mounted() {
    updatePageMeta(PAGE_META);
  },
};
</script>
